interface TextCellProps {
  value: unknown;
}

export function TextCell({ value }: TextCellProps) {
  if (value == null || value === '') return null;
  return <span>{String(value)}</span>;
}
